import { Capability } from './generated/capabilities'

// Friendly Swedish label + one-line description per capability, for the admin role editor.
// Typed as a total Record, so adding a capability without a label fails to compile.
export const CAPABILITY_LABEL: Record<Capability, { label: string, description: string }> = {
    'overview.view': { label: 'Översikt', description: 'Se ekonomin för sina ansvarsområden' },
    'expense.attest': { label: 'Attestera underlag', description: 'Godkänna leverantörsfakturor, utlägg och kortköp inom sitt ansvarsområde' },
    'customer_invoice.send': { label: 'Skicka kundfakturor', description: 'Skapa och skicka fakturor till medlemmar' },
    'customer_invoice.remind': { label: 'Skicka påminnelser', description: 'Påminna om obetalda kundfakturor' },
    'article.create': { label: 'Skapa artiklar', description: 'Lägga till nya artiklar i sina projekt' },
    'eventor.import_invoices': { label: 'Importera Eventor-fakturor', description: 'Importera fakturor för sina tävlingar från Eventor' },
    'eventor.register_payments': { label: 'Förskottstävlingar', description: 'Importera och återrapportera betalningar för förskottstävlingar' },
    'eventor.fix_registrations': { label: 'Rätta tjänstebeställningar',
        description: 'Ändra antal eller ta bort en klubbs beställda tjänster i Eventor, '
            + 'och kreditera mellanskillnaden' },
    'swish.book': { label: 'Bokföra Swish', description: 'Förhandsgranska och bokföra Swish-intäkter' },
    'config.swish_messages': { label: 'Swish-meddelanden', description: 'Hantera affischmeddelanden och deras placering' },
    'config.swish_categories': { label: 'Zettle-kategorier', description: 'Mappa Zettle-kategorier till konton' },
    'config.swish_default': { label: 'Swish standardplacering', description: 'Ange standardkontot när Zettle-kategori saknas' },
    'config.budget': { label: 'Budget', description: 'Ange förväntat resultat per kostnadsställe och verksamhetsår' },
    'member.import': { label: 'Importera medlemmar', description: 'Importera medlemmar från Eventor till Visma' },
    'admin.roles': { label: 'Administrera roller', description: 'Skapa roller, ge behörigheter, ansvarsområden och användare' },
    'admin.eventor_persons': { label: 'Eventor-personer',
        description: 'Koppla Eko-användare till personer i klubben i Eventor' },
    'admin.company_config': { label: 'Föreningskonfiguration', description: 'Redigera kontonamn och konton per projekt' },
}

export const KIND_LABEL: Record<'scoped' | 'company' | 'admin', string> = {
    scoped: 'Inom eget ansvarsområde',
    company: 'Föreningsövergripande',
    admin: 'Administration',
}
